export const ISSUE_RESULT_NOTE_TYPES = {
  ORIGINAL_DESCRIPTION: "OriginalDescription",
  DESCRIPTION: "Description",
  REPAIR_DESCRIPTION: "RepairDescription",
  REVIEW_DESCRIPTION: "ReviewDescription",
  DIAGNOSED_ISSUE: "DiagnosedIssue",
  IS_BILLABLE: "IsBillable",
  INCOMPLETE_REASON: "IncompleteReason",
  VERIFICATION_REQUEST: "VerificationRequest",
  VERIFICATION_RESPONSE: "VerificationResponse",
};

export const getIssueUsers = (attempt, issue, users) => {
  const currentUserId =
    issue.issueResult?.submittedByUserId || attempt.assignedUserId;

  let relatedUserId = null;
  if (attempt.multiTechnicianAttempt) {
    const relatedIssue = attempt.multiTechnicianAttempt.issues.find(
      (x) => x.id === issue.id
    );

    if (relatedIssue) {
      relatedUserId =
        relatedIssue.issueResult?.submittedByUserId ||
        attempt.multiTechnicianAttempt.userId;
    }
  }

  const ids = [relatedUserId, currentUserId].filter(Boolean);

  return users.filter((x) => ids.findIndex((y) => x.id === y) !== -1);
};

const getNewestNote = (notes) =>
  notes.reduce((newest, note) => {
    if (!newest) return note;

    const newestTime = new Date(newest.createdOn).getTime();
    const noteTime = new Date(note.createdOn).getTime();

    return noteTime > newestTime ? note : newest;
  }, null);

export const getNoteHistoryState = ({
  noteHistory = [],
  noteType,
  assignedUserId,
  isApproved = false,
  hasUnsavedChange = false,
}) => {
  const fieldNotes = noteHistory.filter((note) => note.noteType === noteType);
  const hasPreviousNote = fieldNotes.length > 1;
  const latestNote = getNewestNote(fieldNotes);
  const technicianNote = getNewestNote(
    fieldNotes.filter(
      (note) => assignedUserId && note.createdBy === assignedUserId
    )
  );
  const isTechnicianEdit = Boolean(
    latestNote && assignedUserId && latestNote.createdBy === assignedUserId
  );
  const isDispatchEdit = Boolean(
    hasPreviousNote && latestNote && assignedUserId && !isTechnicianEdit
  );
  const isWarning = hasUnsavedChange || isDispatchEdit;

  let state = "default";
  if (isWarning) {
    state = "warning";
  } else if ((hasPreviousNote && isTechnicianEdit) || isApproved) {
    state = "success";
  }

  return {
    state,
    latestNote,
    technicianNote,
    isDispatchEdit,
    hasUnsavedChange,
  };
};
